import { ComponentChildren } from 'preact';
import { Grid } from '../Grid';

type AccordionHeaderModel = {
  uid: string;
  title: string;
  children?: ComponentChildren;
  rowIcon?: ComponentChildren;
  titleIcon?: ComponentChildren;
  endComponents?: ComponentChildren;
  afterTitleComponents?: ComponentChildren;
};

export const AccordionHeader = ({
  uid,
  title,
  children,
  rowIcon = null,
  titleIcon = null,
  afterTitleComponents = null,
  endComponents = null,
}: AccordionHeaderModel) => (
  <label class="cc-accordion-header" for={uid}>
    {rowIcon}
    <span class="cc-accordion-header-title">
      <Grid direction={'horizontal'} collapse={true}>
        <span>{title}</span>
        {titleIcon}
        {children}
      </Grid>
    </span>
    {afterTitleComponents}
    <span class="cc-accordion-reveal-button cc-icon-chevron">
      <em></em>
    </span>
    {endComponents === null ? null : (
      <>
        {endComponents}
      </>
    )}
  </label>
);
